import React from 'react';
import { observer, inject } from "mobx-react";
import { Input, InputFile, SelectInput, Collapsible, DatePicker, InputValidation, Table, Chips, Accordion, Spinner, Pagination  } from '@sogei/react-web-components-catalog'

import { breadcrumbRicevutePegno, breadcrumbTrasmissionePegno } from '../../assets/breadcrumb';
import i18next from 'i18next';
import { Formik } from 'formik';
import * as Yup from 'yup'
import { AppButton } from '../commons/button';
import { decodeTipologica, scrollToTop } from '../commons/uiUtils';
import { regExpDate, regExpRepertorioRaccolta } from '../../assets/utils/regexp';
//TODO: --Usare Denom_ufficio x conservatorie 

@inject("rootStore")
@observer
class RicevuteDuplo extends React.Component {

    constructor(props) {
        super(props);
        this.mostraTabella = undefined
        this.tipologicaStore = props.rootStore.tipologicaStore;
        this.ricevuteDuploStore = props.rootStore.ricevuteDuploStore;
        this.formikRef = React.createRef();
        this.onSubmit = this.onSubmit.bind(this);
        this.validationSchema = Yup.object({
         
          dataRichiestaA: Yup.mixed().test(i18next.t("VALIDATION_DATE_INVALID",{nomeCampo: i18next.t("AL")}),i18next.t("VALIDATION_DATE_INVALID",{nomeCampo: i18next.t("AL")}),(value)=> {
            if(!value) {
              return true;
            }
            return regExpDate(value);
          }),
          dataRichiestaDa: Yup.mixed().test(i18next.t("VALIDATION_DATE_INVALID",{nomeCampo: i18next.t("DAL")}),i18next.t("VALIDATION_DATE_INVALID",{nomeCampo: i18next.t("DAL")}),(value)=> {
            if(!value) {
              return true;
            }
            return regExpDate(value);
          })
          .test('test_dataRichiestaDa_dataRichiestaA',"'Data invio 'Dal' non può essere maggiore di Data invio 'Al'",
      function(value) {
        if (value && this.parent.dataRichiestaA ) {           
            var date_components = value.split("/");
            var day = date_components[0];
            var month = date_components[1];
            var year = date_components[2];
            const dataRichiestaDa_ = new Date(year, month - 1, day);   

            var date_componentsdataRichiestaA = this.parent.dataRichiestaA.split("/");
        
            var daydataRichiestaA = date_componentsdataRichiestaA[0];
            var monthdataRichiestaA = date_componentsdataRichiestaA[1];
            var yeardataRichiestaA = date_componentsdataRichiestaA[2];
            const dataRichiestaA_ = new Date(yeardataRichiestaA, monthdataRichiestaA - 1, daydataRichiestaA);  
            console.log('dataRichiestaA_'+dataRichiestaA_+" - dataRichiestaDa_ "+dataRichiestaDa_)
            return (dataRichiestaDa_ <= dataRichiestaA_);
        }else return true;    
      }),
          repertorioDa: Yup.mixed().test(i18next.t("VALIDATION_REPERTORIO_RACCOLTA",{nomeCampo: i18next.t("DA")}),i18next.t("VALIDATION_REPERTORIO_RACCOLTA",{nomeCampo: i18next.t("DA")}),(value)=> {
            if(!value) {
              return true;
            }
          
            return regExpRepertorioRaccolta(value);
          }),
             
          repertorioA: Yup.mixed().test(i18next.t("VALIDATION_REPERTORIO_RACCOLTA",{nomeCampo: i18next.t("A")}),i18next.t("VALIDATION_REPERTORIO_RACCOLTA",{nomeCampo: i18next.t("A")}),(value)=> {
            if(!value) {
              return true;
            }
           
            return regExpRepertorioRaccolta(value);
          }),
          customValidation: Yup.mixed().test(i18next.t("VALIDATION_ONE_FIELD_MANDATORY_DUPLO"),i18next.t("VALIDATION_ONE_FIELD_MANDATORY_DUPLO"), (value) => {
            if(!this.formikRef.state.values.dataRichiestaDa && !this.formikRef.state.values.repertorioDa) {
              return false;
            }
            return true;
          })
        });
        this.onSubmit = this.onSubmit.bind(this);
        
    }  

    componentDidMount() {
      
      this.tipologicaStore.fetchUfficioConservatorie("A");
      
    }


    componentWillUnmount() { 

    }

  
    onSubmit(values,actions) {
      let params = {};
      let ricercaByDate = $("#idAccordionDatiRicerca-0")[0];
      let ricercaByRepertorio = $("#idAccordionDatiRicerca-1")[0];
      let isVisibleRicercaByDate = ricercaByDate.classList.contains('show');
      if(isVisibleRicercaByDate) {
        actions.setFieldValue('openIndex', 0, false);
        params.openIndex = 0;
      }

      let isVisibleRicercaByRepertorio = ricercaByRepertorio.classList.contains('show');
      if(isVisibleRicercaByRepertorio) {
        actions.setFieldValue('openIndex', 1, false);
        params.openIndex = 1;
      }

      if(isVisibleRicercaByDate && !values.dataRichiestaDa) {
        actions.setFieldValue('repertorioA','',true);
        actions.setFieldValue('repertorioDa','',true);
        return;
      }
      if(isVisibleRicercaByRepertorio && !values.repertorioDa) {
        actions.setFieldValue('dataRichiestaA','',true);
        actions.setFieldValue('dataRichiestaDa','',true);
        return;
      }

      if(values.dataRichiestaDa) {
        params.dataRichiestaDa = values.dataRichiestaDa;
        params.dataRichiestaA = values.dataRichiestaA;
        if(!params.dataRichiestaA) {
          params.dataRichiestaA = params.dataRichiestaDa;
          actions.setFieldValue('dataRichiestaA',values.dataRichiestaDa,false);
        }
      }
      if(values.repertorioDa) {
        params.primoNumeroRepertorioDa = values.repertorioDa.split("/")[0];
        params.secondoNumeroRepertorioDa= values.repertorioDa.split("/")[1];
        
        if(!values.repertorioA) {
          //console.log("values.repertorioA è vuoto: ",values.repertorioA)
          params.primoNumeroRepertorioA = values.repertorioDa.split("/")[0];
          params.secondoNumeroRepertorioA= values.repertorioDa.split("/")[1];
          actions.setFieldValue('repertorioA',values.repertorioDa,false);
        }
        else{
          params.primoNumeroRepertorioA = values.repertorioA.split("/")[0];
          params.secondoNumeroRepertorioA= values.repertorioA.split("/")[1];
        }
      }
      if(values.conservatoria){
        params.codUfficio = values.conservatoria;
        actions.setFieldValue('conservatoria',values.conservatoria,false);
      }
     
      this.setState({pagination:this.initialPagination});

      this.ricevuteDuploStore.fetchRicevute(params).then( () => {
      document.getElementById("cercaRicevute").blur();
      document.getElementById("tabellaDupliTitolo").focus();
      })
      
    }


    

    render() {    
      const listaConservatorie = this.tipologicaStore.ufficioConservatorie;
      //const pagination = this.ricevuteDuploStore.pagination
      const filtriRicerca = this.ricevuteDuploStore.filtriRicerca;
      const listaStatiInvio = this.tipologicaStore.statoInvio;
      const ricevute = this.ricevuteDuploStore.ricevute;
      //const ricevutePaginated = this.ricevuteDuploStore.ricevute ? this.ricevuteDuploStore.ricevute.slice(pagination.start,pagination.start + pagination.limit) : [];
      const loading = this.ricevuteDuploStore.loading;

      
      const validation = (touched, errors) => {
        if((touched.dataRichiestaDa && errors.dataRichiestaDa)
        || (touched.dataRichiestaA && errors.dataRichiestaA)
        || (touched.repertorioDa && errors.repertorioDa)
        || (touched.repertorioA && errors.repertorioA)
        || (touched.customValidation && errors.customValidation)
            ) {
                return <>
                    <InputValidation show={touched.dataRichiestaDa && errors.dataRichiestaDa} error={errors.dataRichiestaDa} />
                    <InputValidation show={touched.dataRichiestaA && errors.dataRichiestaA} error={errors.dataRichiestaA} />
                    <InputValidation show={touched.repertorioDa && errors.repertorioDa} error={errors.repertorioDa} />
                    <InputValidation show={touched.repertorioA && errors.repertorioA} error={errors.repertorioA} />
                    <InputValidation show={touched.customValidation && errors.customValidation} error={errors.customValidation} />
                </>
        }
        return null
    }

    
    const tableHead = (
      <>
        <tr>
            <th scope = "col" style={{verticalAlign:"middle"}} className="text-center text-nowrap" >{i18next.t("CODICE_FISCALE_ROGANTE")}</th>
            <th scope = "col" style={{verticalAlign:"middle"}} className="text-center" >{i18next.t("DATA_PRESENTAZIONE_ATTO")}</th>
            <th scope = "col" style={{verticalAlign:"middle"}} className="text-center" >{i18next.t("CONSERVATORIA")}</th>
            <th scope = "col" style={{verticalAlign:"middle"}} className="text-center" >{i18next.t("REPERTORIO")}</th>
            <th scope = "col" style={{verticalAlign:"middle"}} className="text-center" >{i18next.t("PROTOCOLLO")}</th>
            <th scope = "col" style={{verticalAlign:"middle"}} className="text-center" >{i18next.t("ANNO")}</th>
            <th scope = "col" style={{verticalAlign:"middle"}} className="text-center" >{i18next.t("DATA_RICHIESTA_DUPLO")}</th>
            <th scope = "col" style={{verticalAlign:"middle"}} className="text-center" >{i18next.t("TIPO_RICHIESTA")}</th>
            
            <th scope = "col" style={{verticalAlign:"middle"}} className="text-center" >{i18next.t("DUPLO2")}</th>
        </tr>
        
      </>
  )

  const documentIcon = (border, icon, iconStyle, spanSrOnly, onClick) => {
    let customClass = 'btn btn-light border ' + border;
    let iconCenter = icon + ' ' + iconStyle;
    return <AppButton color="none" spanSrOnly={spanSrOnly} customClass={customClass} iconCenter={iconCenter} type="button"  onClick={onClick} titleKey=''/>
  }
    
  const tableBody =  () =>    this.ricevuteDuploStore.ricevute.length!=0?<> {this.ricevuteDuploStore.ricevute.map(item => {
    
    return(
     
        <tr key={'result_'+item.idPratica}>
            <td className='text-center'>{item.cfRogante}</td>
            <td className='text-center'>{item.dataPresentazioneAtto}</td>
            <td className='text-center'>{listaConservatorie.find( cons => cons.optionValue==item.codUfficio).optionLabel}</td>
            <td className='text-center'>{item.secondoNumRep?item.primoNumRep + "/"+ item.secondoNumRep:item.primoNumRep}</td>
            <td className='text-center'>{item.prot1 + "/"+ item.prot2}</td>
            <td className='text-center'>{item.annoProt}</td>
            <td className='text-center'>{item.dataRichiestaDuplo}</td>
            <td className='text-center'>{item.flagDepositata === "0"? i18next.t("PRESENTAZIONE"):i18next.t("DEPOSITO") }</td>
            <td className='text-center'>{item.p7m ? 
            <AppButton color="outlined-blu" spanSrOnly="BUTTON_DOWNLOAD_P7M" iconCenter={'fas fa-file-signature'} type="button" customClass='mr-2' onClick={() => {this.ricevuteDuploStore.downloadFile({fileMetaData: item.p7m})}} titleKey=''/>
            : ''}</td>
            
        </tr>
        
    )
    
  })} </>:<tr key={'0'}>{i18next.t("TABLE_NO_RESULTS")}</tr>
;
  const tableBodyPegni = () => ricevutePaginated === undefined || ricevutePaginated.length == 0 ? (<tr><td colSpan="10" key={ricevutePaginated.length}><span>{i18next.t("TABLE_NO_RESULTS")}</span></td></tr>)
  : <> {
    ricevutePaginated.map((item,index) => { return (
      <tr key={'result_'+item.idPratica+'_'+index}>
          <td className='text-center'>{item.idPratica}</td>
          <td className='text-center'>{item.utc}</td>
          <td className='text-center'>{item.idPraticaMittente}</td>
          <td className='text-center'>{item.timestampInvio}</td>
          <td className='text-center'>{item.descStato}</td>
          <td className='text-center'>{item.nsr ? 
            documentIcon(item.esitoTerritorio == '1' ? 'border-warning' : 'border-danger','far fa-file-pdf fa', item.esitoTerritorio == '1' ? 'icon-warning' : 'icon-danger','BUTTON_DOWNLOAD_ENTRATE', () => {this.ricevuteDuploStore.downloadFile({fileMetaData: item.nsr})}) 
            : '-'}</td> 
          <td className='text-center'>{item.rsr ? 
            documentIcon(item.esitoEntrate == '1' ? 'border-warning' : 'border-danger','far fa-file-pdf fa', item.esitoEntrate == '1' ? 'icon-warning' : 'icon-danger','BUTTON_DOWNLOAD_PEGNI', () => {this.ricevuteDuploStore.downloadFile({fileMetaData: item.rsr})})  
            : '-'}</td> 
          <td className='text-center'>{item.rdpP7m ? 
            <AppButton color="outlined-blu" spanSrOnly="BUTTON_DOWNLOAD_RICEVUTA_PAGAMENTO_P7M" iconCenter={'fas fa-file-signature'} type="button" customClass='mr-2' onClick={() => {this.ricevuteDuploStore.downloadFile({fileMetaData: item.rdpP7m})}} titleKey=''/>
            : ''}
            {item.rdpPdf ? 
            <AppButton color="outlined-blu" spanSrOnly="BUTTON_DOWNLOAD_RICEVUTA_PAGAMENTO_PDF" iconCenter={'fas fa-file'} type="button"  onClick={() => {this.ricevuteDuploStore.downloadFile({fileMetaData: item.rdpPdf})}} titleKey=''/>
            : ''}</td>
          
      </tr>
  )
  })
  }
  </>

  const getChipsFilter = (label, title, buttonCaption, onClick) => {
    return <Chips
        label={label}
        type="primary"
        title={title}
        buttonCaption={buttonCaption}
        chipIconClass="fas fa-filter"
        buttonIconClass="fas fa-times icon-danger"
        onClick={onClick}
        large={false}
        rootClass={['mx-1']}
    />
  }

  const getDateFilter = () => {
    if(!this.formikRef || !this.formikRef.state || !this.formikRef.state.values) {
      return;
    }
    if (!this.formikRef.state.values.dataRichiestaDa && !this.formikRef.state.values.dataRichiestaA) {
      return undefined;
    }
    let label = i18next.t("CHIPS_FILTRO_DATE",this.formikRef.state.values);
    let title = i18next.t("BUTTON_RIMUOVI_FILTRO");
    let buttonCaption = i18next.t("BUTTON_RIMUOVI_FILTRO");
    return getChipsFilter(label, title, buttonCaption ,() => {
      this.formikRef.getFormikActions().setFieldValue('dataRichiestaA','',false);
      this.formikRef.getFormikActions().setFieldValue('dataRichiestaDa','',false);
      this.formikRef.getFormikActions().submitForm();
    });
  }
  
  const getCodiceInvioFilter = () => {
    if(!this.formikRef || !this.formikRef.state || !this.formikRef.state.values) {
      return;
    }
    if (!this.formikRef.state.values.repertorioDa && !this.formikRef.state.values.repertorioA) {
      return undefined;
    }
    let label = i18next.t("CHIPS_FILTRO_CODICE_INVIO",this.formikRef.state.values);
    let title = i18next.t("BUTTON_RIMUOVI_FILTRO");
    let buttonCaption = i18next.t("BUTTON_RIMUOVI_FILTRO");
    return getChipsFilter(label, title, buttonCaption ,() => {
      this.formikRef.getFormikActions().setFieldValue('repertorioA','',false);
      this.formikRef.getFormikActions().setFieldValue('repertorioDa','',false);
      this.formikRef.getFormikActions().submitForm();
    });
  }

  const getStatoInvioFilter = () => {
    if(!this.formikRef || !this.formikRef.state || !this.formikRef.state.values) {
      return;
    }

    
    let title = i18next.t("BUTTON_RIMUOVI_FILTRO");
    let label = i18next.t("CHIPS_FILTRO_CODICE_INVIO",this.formikRef.state.values); //bo
    let buttonCaption = i18next.t("BUTTON_RIMUOVI_FILTRO");
    return getChipsFilter(label, title, buttonCaption ,() => {
      
      this.formikRef.getFormikActions().submitForm();
    });
  }
  
        
        return (
          <div className="container-fluid pr-3 pl-3 pb-3">
                      <div className="row">              
              <div className="col">
                <h3>{i18next.t("DUPLI_RESTITUITI")}</h3>

                <Formik
                  ref={(ref) => this.formikRef = ref}
                  initialValues={{
                    dataRichiestaDa: filtriRicerca ? filtriRicerca.dataRichiestaDa : '',
                    dataRichiestaA: filtriRicerca ? filtriRicerca.dataRichiestaA :  '',
                   repertorioDa: filtriRicerca ? 
                   
                   (filtriRicerca.secondoNumeroRepertorioDa?
                   (filtriRicerca.primoNumeroRepertorioDa +"/"+ filtriRicerca.secondoNumeroRepertorioDa)
                   :filtriRicerca.primoNumeroRepertorioDa)
                   
                   :  '',                    
                   repertorioA: filtriRicerca ? 
                   
                   (filtriRicerca.secondoNumeroRepertorioA?
                   (filtriRicerca.primoNumeroRepertorioA +"/"+ filtriRicerca.secondoNumeroRepertorioA)
                   :filtriRicerca.primoNumeroRepertorioA)
                   
                   :  '', 
                   conservatoria: filtriRicerca ? filtriRicerca.conservatoria: '',
                    customValidation: '',
                    openIndex: filtriRicerca ? filtriRicerca.openIndex :  0,
                    //pagination: pagination
                  }}
                  validationSchema={this.validationSchema}
                  enableReinitialize={true}
                  onSubmit={(values, actions) => {
                      this.onSubmit(values,actions);
                      
                    }}
                >
                  {props => (
                    <>
                    
                      <div className="my-2">
                          {validation(props.touched, props.errors)}
                      </div>
                      <form onSubmit={props.handleSubmit}>
                      
                          {<>
                            
                            <Accordion
                            openIndex={props.values.openIndex}
                            id="idAccordionDatiRicerca"
                            contentList={[
                              { title: i18next.t("DATA_RICHIESTA_DUPLO"), body: <>

                                    <div className='row'>
                                      <div className='col-sm-12 col-md-6 col-xl-4'>
                                        <DatePicker
                                          id="dataRichiestaDa"
                                          name="dataRichiestaDa"
                                          value={props.values.dataRichiestaDa}
                                          event={{
                                              onChange: (data) => {
                                                  props.setFieldValue('dataRichiestaDa',data)
                                                  props.setFieldValue('repertorioDa','');
                                                  props.setFieldValue('repertorioA','');
                                              }
                                          }}   
                                          error={props.touched.dataRichiestaDa && props.errors.dataRichiestaDa}
                                          extraProps={{}}
                                          inputClass={[]}
                                          label= {[<span key='dataRichiestaDa' className='sr-only'>{i18next.t('DATA')} </span>, i18next.t('DAL')]  }   
                                        ></DatePicker>
                                      </div>
                                      <span className='sr-only'> {i18next.t("DATA_RICHIESTA_DUPLO")} </span>
                                      <div className='col-sm-12 col-md-6 col-xl-4'>
                                        <DatePicker
                                          id="dataRichiestaA"
                                          name="dataRichiestaA"
                                          value={props.values.dataRichiestaA}
                                          event={{
                                              onChange: (data) => {
                                                  props.setFieldValue('dataRichiestaA',data)
                                                  props.setFieldValue('repertorioDa','');
                                                  props.setFieldValue('repertorioA','');
                                              }
                                          }}   
                                          error={props.touched.dataRichiestaA && props.errors.dataRichiestaA}
                                          extraProps={{}}
                                          inputClass={[]}
                                          label= {[<span key='dataRichiestaA' className='sr-only'>{i18next.t('DATA')} </span>, i18next.t('AL')]  }
                                        ></DatePicker>
                                      </div>
                                    </div>
                              </> },
                              {  title: i18next.t("REPERTORIO"), body: <>
                                <div className='row align-items-center'>
                                <span className='sr-only'> {i18next.t("REPERTORIO")} </span>
                                  <div className='col-sm-12 col-md-2 col-xl-2'>
                                    <Input
                                      id="repertorioDa"
                                      name="repertorioDa"
                                      value={props.values.repertorioDa}
                                      type="text"
                                      dimension="lg"
                                      label= {[<span key='repertorioDa' className='sr-only'>{i18next.t('REPERTORIO')} </span>, i18next.t('DAL')]  }
                                      error={props.touched.repertorioDa && props.errors.repertorioDa}
                                      labelClass={[]}
                                      inputClass={[]}
                                      
                                      event={{ onChange:  (event) => {
                                        props.handleChange(event);
                                        props.setFieldValue('dataRichiestaDa','');
                                        props.setFieldValue('dataRichiestaA','');
                                      } }}
                                      extraProps={{placeholder:i18next.t("PLACEHOLDER_REPERTORIO_RACCOLTA")}}
                                    />
                                  </div>
                                 
                                  <div className='col-sm-12 col-md-2 col-xl-2'>
                                  <span className='sr-only'> {i18next.t("REPERTORIO")} </span>
                                    <Input
                                      id="repertorioA"
                                      name="repertorioA"
                                      value={props.values.repertorioA}
                                      type="text"
                                      dimension="lg"
                                      label= {[<span key='repertorioA' className='sr-only'>{i18next.t('REPERTORIO')} </span>, i18next.t('A')]  }
                                      error={props.touched.repertorioA && props.errors.repertorioA}
                                      labelClass={[]}
                                      inputClass={[]}
                                      event={{ onChange:  (event) => {
                                        props.handleChange(event);
                                        props.setFieldValue('dataRichiestaDa','');
                                        props.setFieldValue('dataRichiestaA','');
                                      } }}
                                      extraProps={{placeholder:i18next.t("PLACEHOLDER_REPERTORIO_RACCOLTA")}}
                                    />
                                  </div>
                                </div>
                              </> }
                          ]}
                            />
                            
                          
                          <div className='row'>
                            <div className='col-sm-12 col-md-10 col-xl-10'>
                            <SelectInput
                                        id="conservatoria"
                                        name="conservatoria"
                                        value={props.values.conservatoria}
                                        dimension="lg"
                                        label={i18next.t("CONSERVATORIA")}
                                        firstEmptyOption={true}
                                        optionList={listaConservatorie}
                                        error={props.touched.conservatoria && props.errors.conservatoria}
                                        inputClass={[]}
                                        labelClass={[]}
                                        event={{
                                        onChange: (event) => {
                                            props.handleChange(event)
                                        }
                                        }}

                                        extraProps={{
                                        
                                        }}
                                    />
                            </div>
                          </div>
 
                          
                          <div className='row'>
                            <div className='col-sm-12 col-md-6 col-xl-4'>
                                <AppButton id="cercaRicevute" type="submit" titleKey="BUTTON_CERCA" iconLeft="fas fa-search" spanSrOnly={"Al termine della ricerca i risultati verranno aggiunti in fondo alla pagina"} customClass="mr-2"></AppButton>
                                <AppButton id="ripulisciRicerca" type="reset" titleKey="BUTTON_RIPULISCI" iconLeft="fas fa-eraser" onClick={() => {
                                  props.setFieldValue('dataRichiestaDa','',false);
                                  props.setFieldValue('dataRichiestaA','',false);
                                  props.setFieldValue('repertorioDa','',false);
                                  props.setFieldValue('repertorioA','',false);
                                  props.setFieldValue('customValidation','',false);
                                  document.getElementById("ripulisciRicerca").blur();
                                  
                                }}></AppButton>
                            </div>
                          </div>
                          </>}
                         
                      </form>
                    </>
                  )}
                </Formik>
                
                {loading && <Spinner isLoading={true}> </Spinner>}
                {ricevute != undefined && (<>
                  {/*<div className='row align-items-center'>
                    <div className='col'>
                      <span>{i18next.t("FILTRI_APPLICATI")}</span>
                      {getDateFilter()}
                      {getCodiceInvioFilter()}
                      {getStatoInvioFilter()}
                    </div>
                  </div>*/}
                  <div className='row mt-3' id = "tabellaDupli">
                      <div className='col'>
                        <h4 id = "tabellaDupliTitolo" >{i18next.t("DUPLI_RESTITUITI_TABLE_TITLE") }</h4>
                      <Table tableHead={tableHead} tableBody={tableBody()} tableOptions={['table-header']} />
                      </div>
                  </div>
                  {/* ricevute.length > pagination.limit && (<div className='row'>
                    <div className='col'>
                      <Pagination
                          total={ricevute.length}
                          limit={pagination.limit}
                          pageCount={pagination.pageCount}
                          displayPage={pagination.page}
                          onPageChange={(start, end, page) => {
                            this.ricevuteDuploStore.updatePagination(start, end, page)
                          }}
                      >
                          {" "}
                      </Pagination>
                    </div>
                        </div>)*/}
                </>)}
              </div>
            </div>
          </div>
        ); 
      }
}


export default RicevuteDuplo

export { RicevuteDuplo }

